import {PM} from 'vimmi-web-utils/cjs/postMessage';

let instance;

export class PMWrap extends PM {
  constructor() {
    super()
  }

  static inst() {
    if (!instance) {
      instance = new PMWrap();
    }
    return instance;
  }

  setPlayer(vjsPlayer) {
    this.vjsPlayer = vjsPlayer;
  }

  /**
   * Send postmessage event
   * @method send
   * @param event {String}
   * @param data {any}
   * @param options {Object}
   * @param options.sendMethod {String}
   */
  sendWrappedEvent(event, data, options) {
    options = Object.assign({}, options);
    let defaultData = {};
    if (this.vjsPlayer) {
      defaultData = {
        position: this.vjsPlayer.currentTime(),
        duration: this.vjsPlayer.duration(),
        type: this.vjsPlayer.currentType(),
        src: this.vjsPlayer.currentSrc()
      };
    }
    let sendData = Object.assign(defaultData, data || {});

    this.send({
      target: parent,
      type: event,
      data: sendData,
      sendMethod: options.sendMethod || null
    });
  };
}
